import moment from 'moment';
import numeral from 'numeral';

export function prepareFormObjectForSave(schema: any, form: any, allowNull: boolean = false) {
  allowNull = allowNull || false;

  const normalizedForm = schema.fields.reduce((prev: any, field: any) => {
    const fieldName = field.code;

    if (form[fieldName] !== null|| (allowNull && !form[fieldName])) {
        switch(field.type) {
            case 'interval': {
                if (!form[fieldName].secs) {
                    prev[fieldName] = {
                        'months': 0,
                        'days': 0,
                        'secs': moment.duration(moment(form[fieldName]).utc().local().format('HH:mm:ss')).asSeconds()
                    };
                } else {
                    prev[fieldName] = form[fieldName]
                }
                break;
            }
            case 'date': {
                prev[fieldName] = moment(form[fieldName]).utc().local().format('YYYY-MM-DD');
                break;
            }
            case 'timestamp': {
                prev[fieldName] = moment(form[fieldName]).utc().local().format('YYYY-MM-DD HH:mm:ss');
                break;
            }
            case 'time': {
                prev[fieldName] = moment(form[fieldName]).utc().local().format('HH:mm:ss');
                break;
            }
            case 'credentials': {
                if (form[fieldName] && form[fieldName].password) {
                    prev[fieldName] = {
                        login: form[fieldName].login,
                        password: form[fieldName].password ? form[fieldName].password : ''
                    };
                }
                break;
            }
            case 'integer': {
                prev[fieldName] = form[fieldName] !== null ? numeral(form[fieldName]).value() : 0;
                break;
            }
            case 'decimal': {
                prev[fieldName] = form[fieldName] !== null ? numeral(form[fieldName]).value().toFixed(2) : "0.0";
                break;
            }
            default: {
                prev[fieldName] = form[fieldName]
            }
        }

    } else if (fieldName == 'archived_at' || field.type == 'date' || fieldName == 'credentials') {
        prev[fieldName] = form[fieldName]
    }

    return prev
  }, {});

  return normalizedForm;
}
